import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a certificate icon
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <CertificateIcon width={24} />
 */
const CertificateIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M20.305 10.5L18.825 12.16L19.035 14.36C19.0532 14.5503 19.0013 14.7407 18.8889 14.8954C18.7766
            15.0501 18.6116 15.1584 18.425 15.2L16.225 15.69L15.075 17.59C15.0046 17.7079 14.9051 17.8057 14.786
            17.874C14.6669 17.9423 14.5323 17.9788 14.395 17.98C14.2888 17.9795 14.1837 17.9591 14.085
            17.92L12.005 17.05L9.94498 17.94C9.84281 17.9792 9.7344 17.9995 9.62498 18C9.486 18.0005 9.34928
            17.9648 9.22829 17.8965C9.1073 17.8281 9.00621 17.7293 8.93498 17.61L7.78498 15.71L5.58498
            15.22C5.39931 15.1767 5.23545 15.068 5.12343 14.9137C5.0114 14.7594 4.9587 14.57 4.97498
            14.38L5.18498 12.17L3.69998 10.52C3.57442 10.3778 3.50513 10.1947 3.50513 10.005C3.50513 9.81532
            3.57442 9.63217 3.69998 9.49L5.17998 7.82L4.96998 5.62C4.95237 5.42832 5.00579 5.23686 5.1201
            5.08199C5.2344 4.92712 5.40163 4.81965 5.58998 4.78L7.78998 4.3L8.94998 2.4C9.02034 2.28211 9.11985
            2.18431 9.23894 2.116C9.35803 2.0477 9.4927 2.0112 9.62998 2.01C9.73615 2.01053 9.84128 2.03088 9.93998
            2.07L12 2.95L14.07 2.06C14.1687 2.02088 14.2738 2.00053 14.38 2C14.5188 2.00025 14.6552 2.03627 14.7761
            2.10458C14.8969 2.17289 14.9982 2.27119 15.07 2.39L16.22 4.29L18.42 4.78C18.6057 4.8233 18.7695 4.93204
            18.8815 5.08631C18.9936 5.24058 19.0463 5.43004 19.03 5.62L18.82 7.82L20.305 9.48C20.4351 9.61791
            20.5077 9.80036 20.5077 9.99C20.5077 10.1796 20.4351 10.3621 20.305 10.5ZM8.07998 18.13L7.14998
            16.6L6.68998 16.5L4.99998 21L6.99998 20L7.99998 22L9.14998 18.94C8.70224 18.818 8.3189 18.5278
            8.07998 18.13ZM16.84 16.58L15.92 18.11C15.6787 18.5099 15.2914 18.8003 14.84 18.92L16 22L17
            20L19 21L17.3 16.47L16.84 16.58ZM12 4C10.8133 4 9.65325 4.35189 8.66656 5.01118C7.67986 5.67047
            6.91083 6.60754 6.4567 7.7039C6.00258 8.80026 5.88376 10.0067 6.11527 11.1705C6.34678 12.3344
            6.91823 13.4035 7.75734 14.2426C8.59646 15.0818 9.66555 15.6532 10.8294 15.8847C11.9933 16.1162
            13.1997 15.9974 14.2961 15.5433C15.3924 15.0892 16.3295 14.3201 16.9888 13.3334C17.6481 12.3467
            18 11.1867 18 10C18 8.4087 17.3678 6.88258 16.2426 5.75736C15.1174 4.63214 13.5913 4 12 4ZM12
            5C11.0111 5 10.0444 5.29324 9.22213 5.84265C8.39988 6.39206 7.75902 7.17295 7.38058 8.08658C7.00215
            9.00021 6.90313 10.0055 7.09605 10.9755C7.28898 11.9454 7.76518 12.8363 8.46445 13.5355C9.16371
            14.2348 10.0546 14.711 11.0245 14.9039C11.9944 15.0969 12.9998 14.9978 13.9134 14.6194C14.827
            14.241 15.6079 13.6001 16.1573 12.7779C16.7067 11.9556 17 10.9889 17 10C17 8.67392 16.4732
            7.40215 15.5355 6.46447C14.5978 5.52678 13.3261 5 12 5Z`}
        />
    </SvgIcon>
)

CertificateIcon.defaultProps = defaultProps

export { CertificateIcon }
